import React from "react";
import { LoginModal } from "../Authentication/LoginModal/LoginModal";
import { ConfirmationModal } from "../Result/ConfimationModal/ConfirmationModal";
import { ResultModal } from "../SubmitProcess/ValidationForm/ResultModal/ResultModal";
import { PreviewModal } from "../SubmitProcess/ValidationForm/PreviewFiles/PreviewModal";
import { CopyLinkModal } from "../Result/ResponseSection/CopyLinkModal";
import { AIModelsModal } from "../HomePage/AIModelsModal/AIModelsModal";
import { DiscountableConfirmationModal } from "../Result/DiscountableConfirmationModal/DiscountableConfirmationModal";
import { LogoutModal } from "../Profile/LogoutModal/LogoutModal";
import { WalletCashInModal } from "../SharedComponents/WalletCashInModal/WalletCashInModal";
import { AnnouncedNotificationModal } from "../Notifications/AnnouncedNotificationModal/AnnouncedNotificationModal";
import { NoInternetToast } from "../SharedComponents/NoInternetToast/NoInternetToast";
import { PreviewGeneratedImageModal } from "../ResultAI/ResponseSection/PreviewGeneratedImageModal";
import { PersonalizationModal } from "../SharedComponents/PersonalizationModal/PersonalizationModal";
import { BuyExtraTokensModal } from "../SharedComponents/BuyExtraTokensModal/BuyExtraTokensModal";
import { PreviewSampleModal } from "../SubmitProcess/ServiceSegments/Stepper/Components/PreviewSampleModal";
import { TokenHistoryDetailsModal } from "../TokenHistoryDetails/TokenHistoryDetailsModal/TokenHistoryDetailsModal";
import { BuySubscriptionModal } from "../SharedComponents/BuySubscriptionModal/BuySubscriptionModal";
import { ReferralCodeModal } from "../Authentication/ReferralCodeModal/ReferralCodeModal";
import { ResourcesModal } from "../ResultAI/ResponseSection/ResourcesModal";
import { DeleteKnowledgeModal } from "../AgencyDataList/DeleteKnowledgeModal";
import { RawDataContentModal } from "../AgencyDataList/RawDataContentModal";

export const Modals = () => {
  return (
    <>
      <LoginModal />
      <ConfirmationModal />
      <ResultModal />
      <PreviewModal />
      <CopyLinkModal />
      <AIModelsModal />
      <DiscountableConfirmationModal />
      <LogoutModal />
      <WalletCashInModal />
      <AnnouncedNotificationModal />
      <NoInternetToast />
      <PreviewGeneratedImageModal />
      <PersonalizationModal />
      <BuyExtraTokensModal />
      <PreviewSampleModal />
      <TokenHistoryDetailsModal />
      <BuySubscriptionModal />
      <ReferralCodeModal />
      <ResourcesModal />
      <DeleteKnowledgeModal />
      <RawDataContentModal />
    </>
  );
};
